/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgMsgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 40 40"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="#EE2C4A" rx={20} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M22.5 8v15.5h-5V8h5Zm0 19.5v5.001h-5V27.5h5Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgMsgWarning)
export default Memo
